module.exports = __webpack_public_path__ + "img/hair_front_male_buzzed.32dbea9e.png";